// Import FirebaseAuth and firebase.
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import ROUTES from "../../core/components/Layout/components/Main/components/AppRouter/routes";

// Configure Firebase.

export const initFirebase = () => {
  const config = {
    apiKey: "AIzaSyBEB2HDWwIO2DicxuIQkAJsNfxwDcuFeCI",
    authDomain: "sticker-trader.firebaseapp.com",
    databaseURL: "https://sticker-trader-default-rtdb.firebaseio.com",
    projectId: "sticker-trader",
    storageBucket: "sticker-trader.appspot.com",
    messagingSenderId: "466258555298",
    appId: "1:466258555298:web:c82c37e0c8e969ed3982fb",
    measurementId: "G-25KSYJ9183",
  };

  firebase.initializeApp(config);

  // TODO: Configure recaptcha localization
  // https://firebase.google.com/docs/auth/web/phone-auth?authuser=0#set-up-the-recaptcha-verifier
};

// Configure FirebaseUI.
export const uiConfig: firebaseui.auth.Config = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: ROUTES.UPDATE_PROFILE,
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      defaultCountry: "BR",
      recaptchaParameters: {
        size: "invisible",
      },
    },
  ],
  // Terms of service url.
  tosUrl: "https://figurinhas.web.app/terms",
  // Privacy policy url.
  privacyPolicyUrl: "https://figurinhas.web.app/privacy",
};
